module.exports = __webpack_public_path__ + "static/media/ico-facebook.d6b49c31.svg";